import { DASHBOARD_COUNTS } from "../../constant/ActionType";

export default function AllDashboardCountsReducer(
  state = {
    allCountsDash: [],
    statusCode: null,
  },
  action
) {
  switch (action.type) {
    case DASHBOARD_COUNTS:
      return {
        ...state,
        allCountsDash: action.data,
        statusCode: action.status,
      };

    default:
  }

  return state;
}
